<script setup lang="ts">

import {getImageForJobsite, jobsiteListSubtitle, jobsiteListTitle} from "@/helper/jobsite";
import {DemandBucketManyJobsites, DemandBucketSingleJobsite, Fachbereich, Jobsite} from "@/graphql/generated/graphql";
import RichResponseListItem from "@/views/Chat/RichResponses/components/RichResponseListItem.vue";
import {IonChip, IonIcon} from "@ionic/vue";
import {PropType} from "vue";
import DemandBrowserJobsiteList from "@/views/Chat/RichResponses/DemandBrowserJobsiteList.vue";

const props = defineProps({
    jobsite: {type: Object as PropType<Jobsite>, required: true},
    demandBucket: {type: Object as PropType<DemandBucketSingleJobsite>, required: false},
})

const getLimitedFachbereiche = (fachbereiche: Fachbereich[]) => {
    if (!Array.isArray(fachbereiche)) return []
    return fachbereiche.slice(0, 2)
}

const onClickButtonMoreInfo = (jobsite: Jobsite) => {
    // todo
}

</script>

<template>
    <RichResponseListItem
        iconType="image"
        :icon="getImageForJobsite(jobsite)"
        :title="jobsiteListTitle(jobsite)"
        :button="true"
        @click="onClickButtonMoreInfo(jobsite)"
    >
        <div>
            {{ jobsiteListSubtitle(jobsite, true) }}<br>
            <ion-chip
                color="success"
                class="small"
                v-for="(fb, index) in getLimitedFachbereiche(jobsite.fachbereiche)"
                :key="index"
            >
                {{ fb.abbreviation ?? fb.name }}
            </ion-chip>

            <ion-chip
                color="success"
                v-if="jobsite.fachbereiche.length > 2"
                class="small more-chip"
            >
                +{{ jobsite.fachbereiche.length - 2 }}
            </ion-chip>

            <ion-chip
                color="tertiary"
                class="small"
            >
                {{
                    jobsite?.house?.address?.district
                    ?? jobsite?.house?.address?.city
                    ?? jobsite?.client?.address?.district
                    ?? jobsite?.client?.address?.city
                }}
            </ion-chip>

            <ion-chip v-if="jobsite.bedCount" class="small" color="secondary">
                {{  jobsite.bedCount}} Betten
            </ion-chip>

            <ion-chip v-if="demandBucket?.durchschnittlicheMonatlicheDienste" class="small" color="secondary">
                <!--⌀ -->{{ demandBucket?.durchschnittlicheMonatlicheDienste }} Dienste mtl.
            </ion-chip>
        </div>
    </RichResponseListItem>
</template>

<style scoped lang="scss">

</style>
